import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(categoryDetailLinkListStyles, {
    container: {
        width: 12,
        gap: 20,
        css: css`
            border-radius: 4px;
            padding: 9px;
            padding-bottom: 18px;
        `,
    },
    subCategoryNameLinkItem: {
        width: 12,
        css: css`
           // border-bottom: 1px solid rgb(226, 227, 230);
            padding: 9px 9px 9px 15px;
            background: #f1f6fb;
            & :last-child {
                border-bottom: none;
            }
        `,
    },
    subCategoryNameLink: {
        css: css`
            span {
                line-height: 1.5;
                font-size: 16px;
                font-weight: bold;
            }
        `,
    },
});
